import { environment } from 'src/environments/environment';

/** Settings (language and appearance) live in My-SPA only and apply in every app. */
export function myPreferencesUrl(): string {
  return `${environment.myUrl}/preferences`;
}
